import React, { useState, useEffect, useMemo } from 'react';
import { FaChartLine, FaRocket,FaFileAlt,FaDownload,FaArrowUp,FaArrowDown,FaStar,FaExternalLinkAlt,FaShieldAlt,FaExclamationTriangle,FaSync,FaCalendarAlt,FaPortrait,FaPercentage,FaRupeeSign,FaSearch,FaFilter,FaSortAmountDown,FaSortAmountUp,FaIndustry,FaInfoCircle,FaLeaf,FaSeedling,FaFire,FaCrown,FaTag,FaBriefcase,FaMoneyBillWave,FaLock,FaSignInAlt,FaPhone,FaEnvelope,FaEye,FaTimes,FaFilePdf,FaExternalLinkSquareAlt,FaGoogle,FaClipboardList,FaArrowRight} from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import axios from 'axios';

const AllWeatherPortfolio = () => {
  // ==================== START: LOGIN PROTECTION LOGIC ====================
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [checkingLogin, setCheckingLogin] = useState(true);
  const [userData, setUserData] = useState(null);
  const [contentAccess, setContentAccess] = useState({ AllWeatherPortfolio: 0 });

    // Page metadata========================================================
  const [pageMetadata, setPageMetadata] = useState({
    page_names: 'IPO Research & Analysis',
    description: 'Comprehensive IPO data from SEBI Registered Research Analyst'
  });
  // Add this fetch function (around line 60-80)
  const fetchPageMetadata = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.marketmaestroovip.in'}/api/page-metadata/public/page7`);
      if (response.data) {
        setPageMetadata({
          page_names: response.data.page_name, // Using title from database
          description: response.data.description
        });
      }
    } catch (error) {
      console.error('Error fetching page metadata:', error);
      // Keep default values if fetch fails
    }
  };

  // Add this inside your existing useEffect or create a new one (around line 100-110)
  useEffect(() => {
    if (isLoggedIn && !checkingLogin && contentAccess.AllWeatherPortfolio === 1) {
      fetchPageMetadata(); // Add this line
    }
  }, [isLoggedIn, checkingLogin, contentAccess.AllWeatherPortfolio]);
  // Metadata End===========================================================
  
  const checkLoginStatus = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const userDataStr = localStorage.getItem('user');
      const loggedIn = !!(accessToken && userDataStr);
      setIsLoggedIn(loggedIn);
      
      if (loggedIn) {
        const user = JSON.parse(userDataStr);
        setUserData(user);
        await fetchContentAccess(user.id);
      } else {
        setUserData(null);
        setContentAccess({ AllWeatherPortfolio: 0 });
      }
      
      setCheckingLogin(false);
    } catch (error) {
      console.error('Error checking login status:', error);
      setCheckingLogin(false);
    }
  };
  
  const fetchContentAccess = async (userId) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api.marketmaestroovip.in';
      const response = await axios.get(`${apiUrl}/api/content-access/${userId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      });
      
      if (response.data.success) {
        setContentAccess(response.data.data);
      } else {
        setContentAccess({ AllWeatherPortfolio: 0 });
      }
    } catch (error) {
      console.error('Error fetching content access:', error);
      if (error.response?.status === 404) {
        setContentAccess({ AllWeatherPortfolio: 0 });
      }
    }
  };
  
  useEffect(() => {
    checkLoginStatus();
    
    const handleStorageChange = () => {
      checkLoginStatus();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  // ==================== END: LOGIN PROTECTION LOGIC ====================
  
  // ==================== ORIGINAL COMPONENT STATE ====================
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'recoDate', direction: 'desc' }); // Default sort by Recommended Date descending (newest first)
  const [filter, setFilter] = useState('all');
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [processedData, setProcessedData] = useState({ portfolio: [], ipos: [], researchReports: [], disclosures: [], googleForm: null });

  const API_URL = 'https://sheets.googleapis.com/v4/spreadsheets/1YfIaeY8Ny0LKfhjhdFgHu6btTzZN64WE96Zyxk-z50o/values/ALL%20MM%20WEATHER%20PORTFOLIO?key=AIzaSyBBDGaGd_H-xl8tjzlIZC-Yx2QLMM5FVUA';

  useEffect(() => {
    if (isLoggedIn && !checkingLogin && contentAccess.AllWeatherPortfolio === 1) {
      fetchPortfolioData();
    } else {
      if (isLoggedIn && !checkingLogin) {
        setLoading(false);
      }
    }
  }, [isLoggedIn, checkingLogin, contentAccess.AllWeatherPortfolio]);

  // Auto-refresh every 60 seconds
  useEffect(() => {
    if (isLoggedIn && !checkingLogin && contentAccess.AllWeatherPortfolio === 1) {
      const intervalId = setInterval(() => {
        fetchPortfolioData();
      }, 60000); // 60 seconds
      
      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn, checkingLogin, contentAccess.AllWeatherPortfolio]);

  // Process data when data changes
  useEffect(() => {
    if (data && data.values) {
      const result = processData(data.values);
      setProcessedData(result);
      setColumnHeaders(result.columnHeaders);
    }
  }, [data]);

  const fetchPortfolioData = async () => {
    try {
      setLoading(true);
      console.log('Fetching portfolio data from:', API_URL);
      
      const response = await fetch(API_URL);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Portfolio API Response received');
      
      if (!result.values) {
        throw new Error('No data found in the response');
      }
      
      setData(result);
      setLastUpdated(new Date());
      setLoading(false);
      
    } catch (err) {
      console.error('Error fetching portfolio data:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  // Enhanced Dynamic data processing with NEW badge detection
  const processData = (values) => {
    if (!values) {
      console.log('No data available for processing');
      return { portfolio: [], ipos: [], researchReports: [], disclosures: [], googleForm: null, columnHeaders: [] };
    }

    let portfolio = [];
    let ipos = [];
    let researchReports = [];
    let disclosures = [];
    let googleForm = null;
    let headers = [];
    let portfolioHeadersFound = false;
    let ipoHeadersFound = false;
    
    // Process all rows
    for (let i = 0; i < values.length; i++) {
      const row = values[i];
      if (!row || row.length === 0) continue;
      
      // Check for Google Form link
      const hasGoogleFormLink = row.some(cell => 
        cell && typeof cell === 'string' && cell.includes('forms.gle')
      );
      
      if (hasGoogleFormLink) {
        // Find the Google Form link
        const formLink = row.find(cell => 
          cell && typeof cell === 'string' && cell.includes('forms.gle')
        );
        
        // Find the title (usually in the same row or previous row)
        let formTitle = '';
        if (i > 0 && values[i - 1]) {
          const prevRow = values[i - 1];
          const titleCell = prevRow.find(cell => 
            cell && typeof cell === 'string' && 
            (cell.includes('FILL THIS') || cell.includes('FORM') || cell.includes('Google Form'))
          );
          if (titleCell) {
            formTitle = titleCell;
          }
        }
        
        // Also check current row for title
        if (!formTitle) {
          const titleInRow = row.find(cell => 
            cell && typeof cell === 'string' && 
            (cell.includes('FILL THIS') || cell.includes('FORM') || cell.includes('Google Form'))
          );
          if (titleInRow) {
            formTitle = titleInRow;
          }
        }
        
        if (formLink) {
          googleForm = {
            title: formTitle || 'Google Feedback Form',
            link: formLink,
            description: 'Share your feedback, suggestions, or queries with us'
          };
          console.log('Found Google Form:', googleForm);
        }
        continue;
      }
      
      // Check for portfolio headers with dynamic detection
      const hasSNO = row.some(cell => cell && cell.toString().trim().includes('S.NO'));
      const hasTicker = row.some(cell => cell && cell.toString().trim().includes('TICKER'));
      const hasStockName = row.some(cell => cell && (
        cell.toString().trim().includes('STOCK NAME') || 
        cell.toString().trim().includes('STOCK NAME')
      ));
      const hasRecoPrice = row.some(cell => cell && (
        cell.toString().trim().includes('RECO PRICE') ||
        cell.toString().trim().includes('Reco Price')
      ));
      const hasCMP = row.some(cell => cell && cell.toString().trim().includes('CMP'));
      
      if (hasSNO && hasTicker && hasStockName && (hasRecoPrice || hasCMP)) {
        portfolioHeadersFound = true;
        headers = row.map(h => h ? h.toString().trim() : '');
        console.log('Found portfolio headers at row:', i, 'with headers:', headers);
        
        // Process portfolio rows dynamically
        for (let j = i + 1; j < values.length; j++) {
          const portfolioRow = values[j];
          if (!portfolioRow || portfolioRow.length === 0) continue;
          
          // Stop if we find IPO headers or empty rows
          if (portfolioRow.some(cell => cell && cell.toString().includes('IPO NAME'))) {
            break;
          }
          
          // Skip "COMING SOON" rows
          const firstNonEmpty = portfolioRow.find(cell => cell && cell.toString().trim() !== '');
          if (firstNonEmpty && firstNonEmpty.toString().includes('COMING SOON')) {
            continue;
          }
          
          // CRITICAL FIX: Skip rows that contain Google Drive links (these are research reports, not stocks)
          const hasGoogleDriveLink = portfolioRow.some(cell => 
            cell && typeof cell === 'string' && cell.includes('drive.google.com')
          );
          if (hasGoogleDriveLink) {
            console.log('Skipping row with Google Drive link (research report):', portfolioRow);
            continue;
          }
          
          // Skip rows that are clearly text/headers and not stock data
          const rowText = portfolioRow.join(' ').toLowerCase();
          if (rowText.includes('market maestroo') || 
              rowText.includes('research report') ||
              rowText.includes('sebi registered') ||
              rowText.includes('risk disclosure') ||
              rowText.includes('disclaimer') ||
              rowText.includes('investor caution') ||
              rowText.includes('fill this google form')) {
            continue;
          }
          
          // Create complete stock object with ALL columns
          const stockObj = {};
          let hasValidData = false;
          let sno = null;
          let isNew = false;
          
          // Map ALL columns - STORE ALL VALUES AS STRINGS FIRST
          headers.forEach((header, index) => {
            if (header) {
              const rawValue = portfolioRow[index] ? portfolioRow[index].toString().trim() : '';
              
              // Check for "NEW" column
              if (header.toLowerCase().includes('new')) {
                isNew = rawValue.toLowerCase().includes('new');
                stockObj[header] = rawValue;
              }
              // Store S.NO for ID
              else if (header.includes('S.NO') || header.includes('NO.')) {
                sno = parseInt(rawValue) || j;
                stockObj[header] = sno;
                stockObj.id = sno;
              }
              // Store ALL values as strings initially - NO PARSING for display
              else {
                stockObj[header] = rawValue;
              }
              
              // Check if this row has valid data - require actual stock data, not empty
              if ((header.includes('TICKER') && rawValue && !rawValue.includes('COMING SOON')) || 
                  (header.includes('STOCK') && rawValue && rawValue !== '') ||
                  (header.includes('NAME') && rawValue && rawValue !== '' && !header.includes('IPO'))) {
                hasValidData = true;
              }
            }
          });
          
          // Additional validation: make sure we have actual stock data (ticker or stock name with value)
          const hasValidTicker = stockObj['TICKER'] && stockObj['TICKER'] !== '' && !stockObj['TICKER'].includes('COMING SOON');
          const hasValidStockName = stockObj['STOCK NAME'] && stockObj['STOCK NAME'] !== '';
          
          if (hasValidData && sno && (hasValidTicker || hasValidStockName)) {
            // Extract key values with fallbacks
            const ticker = stockObj['TICKER'] || stockObj['Ticker'] || stockObj['Symbol'] || '';
            const stockName = stockObj['STOCK NAME'] || stockObj['STOCK NAME'] || 
                             stockObj['Company Name'] || stockObj['COMPANY'] || 
                             stockObj['Stock Name'] || '';
            
            // Dynamically find important columns
            const recoPriceHeader = headers.find(h => 
              (h.includes('RECO') && h.includes('PRICE')) || 
              h.includes('Recommendation Price') ||
              h.includes('Entry Price') ||
              h === 'Reco Price'
            );
            
            const cmpHeader = headers.find(h => 
              h.includes('CMP') || 
              h.includes('Current Price') ||
              h.includes('LTP') ||
              h.includes('Market Price')
            );
            
            const returnHeader = headers.find(h => 
              h.includes('RETURN') || 
              h.includes('Return') ||
              (h.includes('%') && !h.includes('Date'))
            );
            
            const dateHeader = headers.find(h => 
              h.includes('DATE') || 
              h.includes('Date') ||
              h.includes('RECO DATE')
            );
            
            // Get numeric values for calculations, but keep original strings for display
            let recoPrice = 0;
            let recoPriceDisplay = '';
            if (recoPriceHeader && stockObj[recoPriceHeader]) {
              recoPriceDisplay = stockObj[recoPriceHeader];
              const cleanValue = String(stockObj[recoPriceHeader]).replace(/[^0-9.-]/g, '');
              recoPrice = parseFloat(cleanValue) || 0;
            }
            
            let cmp = 0;
            let cmpDisplay = '';
            if (cmpHeader && stockObj[cmpHeader]) {
              cmpDisplay = stockObj[cmpHeader];
              const cleanValue = String(stockObj[cmpHeader]).replace(/[^0-9.-]/g, '');
              cmp = parseFloat(cleanValue) || 0;
            }
            
            let returnPercentage = 0;
            let returnDisplay = '';
            if (returnHeader && stockObj[returnHeader]) {
              returnDisplay = stockObj[returnHeader];
              const cleanValue = String(stockObj[returnHeader]).replace(/[^0-9.-]/g, '');
              returnPercentage = parseFloat(cleanValue) || 0;
            }
            
            const recoDate = dateHeader ? (stockObj[dateHeader] || '') : '';
            const absoluteReturn = cmp - recoPrice;
            
            // Preserve original order by storing original index
            portfolio.push({
              id: sno,
              ticker: ticker,
              stockName: stockName,
              recoPrice: recoPrice, // Numeric for calculations
              recoPriceDisplay: recoPriceDisplay, // Original string for display
              cmp: cmp, // Numeric for calculations
              cmpDisplay: cmpDisplay, // Original string for display
              return: returnPercentage, // Numeric for calculations
              returnDisplay: returnDisplay, // Original string for display
              returnPercentage: returnPercentage,
              recoDate: recoDate,
              absoluteReturn: absoluteReturn,
              isPositive: returnPercentage > 0,
              isNew: isNew,
              // Store ALL dynamic data
              dynamicData: stockObj,
              columnHeaders: headers,
              hasDynamicData: true,
              originalIndex: j // Preserve original order
            });
          }
        }
      }
      
      // Check for IPO headers dynamically
      const hasIPOName = row.some(cell => cell && cell.toString().trim().includes('IPO NAME'));
      const hasIPOPrice = row.some(cell => cell && (
        cell.toString().trim().includes('IPO PRICE') ||
        cell.toString().trim().includes('Price Range')
      ));
      
      if (hasSNO && hasIPOName && hasIPOPrice) {
        ipoHeadersFound = true;
        const ipoHeaders = row.map(h => h ? h.toString().trim() : '');
        console.log('Found IPO headers at row:', i, 'with headers:', ipoHeaders);
        
        // Process IPO rows dynamically
        for (let j = i + 1; j < values.length; j++) {
          const ipoRow = values[j];
          if (!ipoRow || ipoRow.length === 0) continue;
          
          // Skip empty or incomplete rows
          const hasContent = ipoRow.some(cell => cell && cell.toString().trim() !== '');
          if (!hasContent) continue;
          
          // Create IPO object with ALL columns
          const ipoObj = {};
          let hasValidIPOData = false;
          let ipoSno = null;
          
          // Map ALL IPO columns
          ipoHeaders.forEach((header, index) => {
            if (header) {
              const rawValue = ipoRow[index] ? ipoRow[index].toString().trim() : '';
              
              // Store S.NO for ID
              if (header.includes('S.NO') || header.includes('NO.')) {
                ipoSno = parseInt(rawValue) || j;
                ipoObj[header] = ipoSno;
                ipoObj.id = ipoSno;
              }
              // Store other values
              else {
                ipoObj[header] = rawValue;
              }
              
              // Check if this row has valid data
              if (header.includes('NAME') && rawValue) {
                hasValidIPOData = true;
              }
            }
          });
          
          if (hasValidIPOData && ipoSno) {
            ipos.push({
              ...ipoObj,
              dynamicData: ipoObj,
              columnHeaders: ipoHeaders,
              hasDynamicData: true
            });
          }
        }
      }
      
      // Check for research reports (look for Google Drive links) - IMPROVED DETECTION
      // Check if row has a Google Drive link AND has a company name (not a stock row)
      const hasDriveLink = row.some(cell => cell && typeof cell === 'string' && cell.includes('drive.google.com'));
      
      if (hasDriveLink) {
        // Find the company name - it's usually in the first column
        const companyName = row[0] ? row[0].toString().trim() : '';
        const reportLink = row.find(cell => cell && typeof cell === 'string' && cell.includes('drive.google.com')) || '';
        
        // Only add if we have both company name and link, and it's not part of stock data
        if (companyName && reportLink && 
            !companyName.includes('COMING SOON') && 
            !companyName.includes('S.NO') &&
            !companyName.includes('TICKER') &&
            companyName.length > 2) {
          
          // Check if this company is already in researchReports to avoid duplicates
          const isDuplicate = researchReports.some(r => r.companyName === companyName);
          if (!isDuplicate) {
            researchReports.push({
              companyName: companyName,
              reportLink: reportLink,
              reportDate: new Date().toLocaleDateString(),
              additionalInfo: row[1] || row[2] || row[3] || ''
            });
            console.log('Added research report:', companyName);
          }
        }
      }
      
      // Process disclosures
      if (row.length > 0 && row[0]) {
        const text = row[0].toString();
        if (text.includes('SEBI REGISTERED')) {
          disclosures.push({ type: 'registration', text: text });
        } else if (text.includes('RISK DISCLOSURE')) {
          disclosures.push({ type: 'risk', text: text });
        } else if (text.includes('DISCLAIMER')) {
          disclosures.push({ type: 'disclaimer', text: text });
        } else if (text.includes('INVESTOR CAUTION')) {
          disclosures.push({ type: 'caution', text: text });
        }
      }
    }
    
    // Sort portfolio by original index to preserve API order
    portfolio.sort((a, b) => a.originalIndex - b.originalIndex);
    
    console.log('Processed data:', {
      portfolio: portfolio.length,
      ipos: ipos.length,
      researchReports: researchReports.length,
      disclosures: disclosures.length,
      googleForm: googleForm ? 'Found' : 'Not found'
    });
    
    console.log('Portfolio stocks (preserved order):', portfolio.map(s => ({ id: s.id, name: s.stockName, ticker: s.ticker, index: s.originalIndex })));
    console.log('Research reports:', researchReports);
    
    return { portfolio, ipos, researchReports, disclosures, googleForm, columnHeaders: headers };
  };

  // Get ALL dynamic fields for display
  const getAllDisplayableFields = (stock) => {
    if (!stock.dynamicData) return [];
    
    // Fields already shown in main section
    const alreadyDisplayed = [
      'S.NO', 'TICKER', 'STOCK NAME', 'STOCK NAME',
      'RECO PRICE', 'CMP', 'RETURN', 'RECO DATE',
      'Reco Price', 'CMP', 'RETURN', 'Reco Date',
      'Company Name', 'SYMBOL', 'Ticker',
      'id', 'ticker', 'stockName', 'recoPrice', 'cmp', 
      'return', 'returnPercentage', 'recoDate', 'absoluteReturn', 
      'isPositive', 'dynamicData', 'columnHeaders', 'hasDynamicData',
      'isNew', 'NEW', 'New', 'recoPriceDisplay', 'cmpDisplay', 'returnDisplay'
    ];
    
    const allFields = [];
    
    Object.entries(stock.dynamicData).forEach(([key, value]) => {
      const keyUpper = key.toUpperCase();
      const isExcluded = alreadyDisplayed.some(excluded => 
        keyUpper.includes(excluded.toUpperCase())
      );
      
      if (!isExcluded && 
          value !== undefined && 
          value !== null && 
          value.toString().trim() !== '' &&
          !(typeof value === 'number' && value === 0)) {
        
        const displayName = formatHeaderName(key);
        allFields.push({
          key,
          displayName,
          value,
          isNumeric: typeof value === 'number',
          isPercentage: keyUpper.includes('%') || keyUpper.includes('RETURN') || keyUpper.includes('PERCENT'),
          isCurrency: (keyUpper.includes('PRICE') || keyUpper.includes('VALUE') || 
                      keyUpper.includes('AMOUNT') || keyUpper.includes('CMP')) && 
                      typeof value === 'number'
        });
      }
    });
    
    return allFields;
  };

  // Format header names for display
  const formatHeaderName = (header) => {
    return header
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .replace(/\./g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  // Format value for display
  const formatValue = (field) => {
    if (field.isNumeric) {
      if (field.isPercentage) {
        return `${field.value >= 0 ? '+' : ''}${field.value.toFixed(2)}%`;
      } else if (field.isCurrency) {
        return `₹${field.value.toFixed(2)}`;
      } else {
        return field.value % 1 === 0 ? field.value.toString() : field.value.toFixed(2);
      }
    }
    return field.value.toString();
  };

  // Clear all filters and sorting
  const clearAllFilters = () => {
    setSearchTerm('');
    setFilter('all');
    setSortConfig({ key: 'recoDate', direction: 'desc' }); // Reset to default date sort
  };

  const filteredAndSortedPortfolio = useMemo(() => {
    let filtered = [...processedData.portfolio];
    
    // Apply search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(stock => 
        stock.ticker.toLowerCase().includes(term) ||
        stock.stockName.toLowerCase().includes(term)
      );
    }
    
    // Apply gainer/loser filter
    if (filter === 'gainers') {
      filtered = filtered.filter(stock => stock.return > 0);
    } else if (filter === 'losers') {
      filtered = filtered.filter(stock => stock.return < 0);
    }
    
    // Apply sorting
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];
        
        // Special handling for date sorting
        if (sortConfig.key === 'recoDate') {
          // Convert dates to comparable format (assuming DD/MM/YYYY or similar)
          const parseDate = (dateStr) => {
            if (!dateStr || dateStr === 'N/A' || dateStr === '') return new Date(0);
            // Try to parse common date formats
            const parts = dateStr.split(/[/-]/);
            if (parts.length === 3) {
              // Assume DD/MM/YYYY or MM/DD/YYYY - try both
              let day, month, year;
              if (parts[0].length === 4) {
                // YYYY-MM-DD format
                return new Date(dateStr);
              } else if (parts[0].length === 2 && parts[1].length === 2) {
                // DD/MM/YYYY format (most common in India)
                day = parseInt(parts[0]);
                month = parseInt(parts[1]) - 1;
                year = parseInt(parts[2]);
                return new Date(year, month, day);
              } else {
                return new Date(dateStr);
              }
            }
            return new Date(dateStr);
          };
          
          aValue = parseDate(aValue);
          bValue = parseDate(bValue);
        }
        
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    } else {
      // Preserve original order when no sort is applied
      filtered.sort((a, b) => a.originalIndex - b.originalIndex);
    }
    
    return filtered;
  }, [processedData.portfolio, searchTerm, filter, sortConfig]);

  const portfolioStats = useMemo(() => {
    const portfolio = processedData.portfolio;
    if (portfolio.length === 0) return null;
    
    const totalInvested = portfolio.reduce((sum, stock) => sum + stock.recoPrice, 0);
    const currentValue = portfolio.reduce((sum, stock) => sum + stock.cmp, 0);
    const totalReturn = portfolio.reduce((sum, stock) => sum + stock.absoluteReturn, 0);
    const totalReturnPercentage = ((currentValue - totalInvested) / totalInvested) * 100;
    const avgReturn = portfolio.reduce((sum, stock) => sum + stock.return, 0) / portfolio.length;
    const positiveStocks = portfolio.filter(s => s.return > 0).length;
    const negativeStocks = portfolio.filter(s => s.return < 0).length;
    const neutralStocks = portfolio.filter(s => s.return === 0).length;
    
    return {
      totalStocks: portfolio.length,
      totalInvested,
      currentValue,
      totalReturn,
      totalReturnPercentage,
      avgReturn,
      positiveStocks,
      negativeStocks,
      neutralStocks
    };
  }, [processedData.portfolio]);

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  // Simple function to return date as-is from API
  const displayDate = (dateString) => {
    if (!dateString || dateString === '') return 'N/A';
    return dateString; // Return exactly as received from API
  };
  
  // ==================== LOGIN PROTECTION RENDER LOGIC ====================
  if (checkingLogin) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white relative">
          <div className="absolute inset-0 backdrop-blur-[5px] bg-white/80 z-10 flex items-center justify-center">
            <motion.div 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 border border-gray-200"
            >
              <div className="text-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-100 to-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FaLock className="text-3xl text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Authentication Required</h2>
                <p className="text-gray-600 mb-1">You need to log in to access the Portfolio Dashboard.</p>
                <p className="text-sm text-gray-500 mb-6">This content is exclusive to registered members.</p>
                <Link to="/login">
                  <button className="w-full py-3.5 px-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-3">
                    <FaSignInAlt className="text-lg" />
                    Go to Login Page
                  </button>
                </Link>
                <div className="mt-6 pt-6 border-t border-gray-100">
                  <p className="text-sm text-gray-500">
                    Don't have an account?{' '}
                    <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500">
                      Sign up here
                    </Link>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="opacity-40 pointer-events-none">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <div>
                    <h1 className="text-3xl md:text-4xl font-bold mb-2">Market Maestroo Portfolio Dashboard</h1>
                    <p className="text-blue-100">Comprehensive portfolio analysis and research reports</p>
                    <p className="text-blue-200 text-sm mt-1">SEBI Registered Research Analyst (INH000021757)</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="text-center py-20">
                <p className="text-gray-400">Content blurred for privacy. Please login to view.</p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  if (contentAccess.AllWeatherPortfolio !== 1) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white relative">
          <div className="absolute inset-0 backdrop-blur-[5px] bg-white/80 z-10 flex items-center justify-center">
            <motion.div 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 border border-gray-200"
            >
              <div className="text-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-r from-amber-100 to-amber-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FaLock className="text-3xl text-amber-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Content Access Restricted</h2>
                <p className="text-gray-600 mb-3">
                  Hello <span className="font-semibold text-blue-600">{userData?.username}</span>! 
                  You don't have access to the Portfolio Dashboard yet.
                </p>
                <p className="text-sm text-gray-500 mb-6">
                  This premium content requires special access permissions.
                </p>
                <div className="space-y-3">
                  <a 
                    href="tel:+919319745997"
                    className="w-full py-3.5 px-6 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-3"
                  >
                    <FaPhone className="text-lg" />
                    Call Us: +91 9319745997
                  </a>
                  <a 
                    href="mailto:support@marketmaestroo.com"
                    className="w-full py-3.5 px-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-3"
                  >
                    <FaEnvelope className="text-lg" />
                    Email: support@marketmaestroo.com
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="opacity-40 pointer-events-none">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <div>
                    <h1 className="text-3xl md:text-4xl font-bold mb-2">Market Maestroo Portfolio Dashboard</h1>
                    <p className="text-blue-100">Comprehensive portfolio analysis and research reports</p>
                    <p className="text-blue-200 text-sm mt-1">SEBI Registered Research Analyst (INH000021757)</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="text-center py-20">
                <p className="text-gray-400">Content access restricted.</p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // ==================== MAIN RENDER LOGIC ====================
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading Portfolio Dashboard...</p>
          <p className="text-sm text-gray-500 mt-2">Auto-refresh every 60 seconds</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg border border-red-100 max-w-md">
          <FaExclamationTriangle className="text-red-500 text-4xl mx-auto mb-4" />
          <h3 className="text-xl font-bold text-gray-900 mb-2">Error Loading Portfolio</h3>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            onClick={fetchPortfolioData}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2 mx-auto"
          >
            <FaSync />
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              <div className="flex flex-col md:flex-row items-center justify-between">
                <div>
                  <h1 className="text-3xl md:text-4xl font-bold mb-2">{pageMetadata.page_names}</h1>
                  <p className="text-blue-100">{pageMetadata.description}</p>
                  <p className="text-blue-200 text-sm mt-1">SEBI Registered Research Analyst (INH000021757)</p>
                </div>
                <div className="mt-4 md:mt-0 flex flex-col md:flex-row items-center gap-4">
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                    <FaShieldAlt className="text-yellow-300" />
                    <span className="font-semibold">SEBI INH000021757</span>
                  </div>
                  <button
                    onClick={fetchPortfolioData}
                    className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors"
                  >
                    <FaSync className="text-sm" />
                    Refresh Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 py-16">
            {/* Search and Filter Controls */}
            <div className="mb-8">
              <div className="flex flex-col md:flex-row gap-4 mb-4">
                <div className="flex-1">
                  <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      placeholder="Search by stock name, ticker..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
                    />
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setFilter('all')}
                    className={`px-4 py-2 rounded-lg transition-colors ${
                      filter === 'all' 
                        ? 'bg-blue-600 text-white' 
                        : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-300'
                    }`}
                  >
                    All Stocks
                  </button>
                  <button
                    onClick={() => setFilter('gainers')}
                    className={`px-4 py-2 rounded-lg transition-colors flex items-center gap-2 ${
                      filter === 'gainers' 
                        ? 'bg-green-600 text-white' 
                        : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-300'
                    }`}
                  >
                    <FaArrowUp />
                    Gainers
                  </button>
                  <button
                    onClick={() => setFilter('losers')}
                    className={`px-4 py-2 rounded-lg transition-colors flex items-center gap-2 ${
                      filter === 'losers' 
                        ? 'bg-red-600 text-white' 
                        : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-300'
                    }`}
                  >
                    <FaArrowDown />
                    Losers
                  </button>
                  <button
                    onClick={clearAllFilters}
                    className="px-4 py-2 rounded-lg transition-colors flex items-center gap-2 bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300"
                  >
                    <FaTimes />
                    Clear Filters
                  </button>
                </div>
              </div>

              {/* Sort Controls */}
              <div className="flex items-center gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex-wrap">
                <span className="text-gray-600 font-medium">Sort by:</span>
                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={() => handleSort('recoDate')}
                    className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-colors ${
                      sortConfig.key === 'recoDate' 
                        ? 'bg-blue-100 text-blue-700 border border-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    Recommended Date
                    {sortConfig.key === 'recoDate' && (
                      sortConfig.direction === 'desc' ? <FaSortAmountDown /> : <FaSortAmountUp />
                    )}
                  </button>
                  <button
                    onClick={() => handleSort('return')}
                    className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-colors ${
                      sortConfig.key === 'return' 
                        ? 'bg-blue-100 text-blue-700 border border-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    Return %
                    {sortConfig.key === 'return' && (
                      sortConfig.direction === 'desc' ? <FaSortAmountDown /> : <FaSortAmountUp />
                    )}
                  </button>
                  <button
                    onClick={() => handleSort('cmp')}
                    className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-colors ${
                      sortConfig.key === 'cmp' 
                        ? 'bg-blue-100 text-blue-700 border border-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    Current Price
                    {sortConfig.key === 'cmp' && (
                      sortConfig.direction === 'desc' ? <FaSortAmountDown /> : <FaSortAmountUp />
                    )}
                  </button>
                  <button
                    onClick={() => handleSort('absoluteReturn')}
                    className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-colors ${
                      sortConfig.key === 'absoluteReturn' 
                        ? 'bg-blue-100 text-blue-700 border border-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    Absolute Return
                    {sortConfig.key === 'absoluteReturn' && (
                      sortConfig.direction === 'desc' ? <FaSortAmountDown /> : <FaSortAmountUp />
                    )}
                  </button>
                </div>
                {sortConfig.key && (
                  <button
                    onClick={() => setSortConfig({ key: 'recoDate', direction: 'desc' })}
                    className="ml-auto text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
                  >
                    <FaTimes className="text-xs" />
                    Reset to Date Sort
                  </button>
                )}
                <div className="ml-auto text-sm text-gray-500">
                  {filteredAndSortedPortfolio.length} stocks found
                  {columnHeaders.length > 0 && ` • ${columnHeaders.length} columns`}
                </div>
              </div>
            </div>

            {/* Stock Cards - Shows ALL columns */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              

              {filteredAndSortedPortfolio.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-2xl shadow-sm border border-gray-200">
                  <FaChartLine className="text-gray-400 text-4xl mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">No Stocks Found</h3>
                  <p className="text-gray-500">Try adjusting your search or filter criteria</p>
                  <button 
                    onClick={clearAllFilters}
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                  >
                    Clear Filters
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
                  {filteredAndSortedPortfolio.map((stock, index) => {
                    const dynamicFields = getAllDisplayableFields(stock);
                    
                    return (
                      <motion.div
                        key={stock.id}
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3, delay: index * 0.05 }}
                        whileHover={{ y: -4 }}
                        className="group relative"
                      >
                        {/* New Badge - Display as diagonal ribbon in top right corner */}
                        {stock.isNew && (
                          <div className="absolute top-0 right-0 z-20 overflow-hidden w-24 h-24">
                            <div 
                              className="absolute top-10 transform -translate-x-1/2 -translate-y-1/2 rotate-45 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-xs font-bold py-1 px-6 shadow-lg"
                              style={{ right: "-57px", top: "18px" }}
                            >
                              NEW
                            </div>
                          </div>
                        )}

                        {/* Stock Card */}
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border border-gray-200 transition-all duration-300 overflow-hidden hover:border-blue-300 hover:shadow-xl h-full">
                          {/* {stock.return > 10 && (
                            <div className="absolute top-4 right-4 z-10">
                              <div className="bg-gradient-to-r from-green-400 to-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-lg">
                                <FaCrown className="text-xs" />
                                Top Performer
                              </div>
                            </div>
                          )} */}

                          <div className="p-5">
                            {/* Stock Header */}
                            <div className="flex items-start justify-between mb-4">
                              <div className="flex-1">
                                <h3 className="font-bold text-gray-900 text-lg line-clamp-1 group-hover:text-blue-600 transition-colors">
                                  {stock.stockName}
                                </h3>
                                <div className="flex items-center mt-1">
                                  <span className="text-sm font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded">
                                    {stock.ticker}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Core Metrics Section - Using display values */}
                            <div className="mb-4">
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                <div className="bg-gray-50 p-3 rounded-lg">
                                  <div className="text-xs text-gray-500 mb-1">Current Price</div>
                                  <div className="font-bold text-gray-900 text-lg">
                                    ₹{stock.cmpDisplay || stock.cmp}
                                  </div>
                                </div>
                                <div className="bg-blue-50 p-3 rounded-lg">
                                  <div className="text-xs text-blue-600 mb-1">Reco Price</div>
                                  <div className="font-bold text-blue-700 text-lg">
                                    ₹{stock.recoPriceDisplay || stock.recoPrice}
                                  </div>
                                </div>
                              </div>

                              {/* Return Metrics */}
                              <div className={`p-3 rounded-lg ${stock.isPositive ? 'bg-green-50' : 'bg-red-50'}`}>
                                <div className="flex justify-between items-center">
                                  <span className="text-sm font-medium text-gray-700">Total Return</span>
                                  <div className={`text-lg font-bold ${stock.isPositive ? 'text-green-600' : 'text-red-600'} flex items-center gap-1`}>
                                    {stock.isPositive ? <FaArrowUp className="text-sm" /> : <FaArrowDown className="text-sm" />}
                                    {stock.returnDisplay || stock.return}%
                                  </div>
                                </div>
                                <div className="text-xs text-gray-600 mt-1">
                                  Absolute: ₹{stock.absoluteReturn >= 0 ? '+' : ''}{Math.abs(stock.absoluteReturn).toFixed(2)}
                                </div>
                              </div>
                            </div>

                            {/* ALL Dynamic Fields Section - Shows everything except NEW column */}
                            {dynamicFields.length > 0 && (
                              <div className="mt-4 pt-4 border-t border-gray-200">
                                <div className="flex items-center justify-between mb-3">
                                  <h4 className="text-sm font-semibold text-gray-700">Additional Data</h4>
                                  <span className="text-xs text-gray-500">
                                    {dynamicFields.length} fields
                                  </span>
                                </div>
                                
                                <div className="space-y-3">
                                  {dynamicFields.map((field, idx) => (
                                    <div 
                                      key={idx} 
                                      className={`p-2.5 rounded-lg ${field.isPercentage || field.isCurrency ? 'bg-blue-50' : 'bg-gray-50'}`}
                                    >
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <div className="text-xs font-medium text-gray-600 mb-0.5">
                                            {field.displayName}
                                          </div>
                                          <div className={`text-sm font-bold ${
                                            field.isPercentage 
                                              ? field.value >= 0 ? 'text-green-600' : 'text-red-600'
                                              : field.isCurrency ? 'text-blue-700' : 'text-gray-900'
                                          }`}>
                                            {formatValue(field)}
                                          </div>
                                        </div>
                                        {field.isPercentage && (
                                          <div className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
                                            field.value >= 0 
                                              ? 'bg-green-100 text-green-800' 
                                              : 'bg-red-100 text-red-800'
                                          }`}>
                                            {field.value >= 0 ? '+' : ''}{field.value.toFixed(1)}%
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {stock.recoDate && (
                              <div className="mt-4 pt-3 border-t border-gray-200">
                                <div className="flex items-center justify-between text-sm">
                                  <div className="flex items-center gap-2 text-gray-600">
                                    <FaCalendarAlt className="text-gray-400 text-xs" />
                                    <span>Recommended Date</span>
                                  </div>
                                  <span className="font-medium text-gray-900">{String(stock.recoDate)}</span>
                                </div>
                              </div>
                            )}

                            {/* Footer */}
                            {/* <div className="mt-4 pt-3 border-t border-gray-100">
                              <div className="flex items-center justify-between text-xs text-gray-500">
                                <span>Stock ID: {stock.id}</span>
                                <span className={`px-2 py-0.5 rounded-full ${
                                  stock.return > 20 ? 'bg-green-100 text-green-800' :
                                  stock.return > 0 ? 'bg-blue-100 text-blue-800' :
                                  stock.return > -10 ? 'bg-amber-100 text-amber-800' :
                                  'bg-red-100 text-red-800'
                                }`}>
                                  {stock.return > 20 ? 'Strong Buy' :
                                  stock.return > 0 ? 'Buy' :
                                  stock.return > -10 ? 'Hold' : 'Review'}
                                </span>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
              )}
            </motion.div>

            {/* Research Reports Section - Display only if there are research reports */}
            {processedData.researchReports.length > 0 && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mt-12"
              >
                <div className="bg-gradient-to-r from-white to-blue-50 rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
                  <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                    <h3 className="text-xl font-bold text-white flex items-center gap-2">
                      <FaFilePdf className="text-red-300 text-2xl" />
                      Research Reports
                      <span className="text-sm bg-white/20 px-2 py-1 rounded-full ml-2">
                        {processedData.researchReports.length} Reports
                      </span>
                    </h3>
                    <p className="text-blue-100 text-sm mt-1">
                      In-depth analysis and research reports from Market Maestroo
                    </p>
                  </div>
                  
                  <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      {processedData.researchReports.map((report, index) => {
                        // Extract file ID from Google Drive link for preview thumbnail
                        const getDriveFileId = (url) => {
                          const patterns = [
                            /\/d\/([a-zA-Z0-9_-]+)/,
                            /id=([a-zA-Z0-9_-]+)/,
                            /file\/d\/([a-zA-Z0-9_-]+)/
                          ];
                          for (const pattern of patterns) {
                            const match = url.match(pattern);
                            if (match) return match[1];
                          }
                          return null;
                        };
                        
                        const fileId = getDriveFileId(report.reportLink);
                        const thumbnailUrl = fileId ? `https://drive.google.com/thumbnail?id=${fileId}&sz=w200` : null;
                        
                        return (
                          <motion.a
                            key={index}
                            href={report.reportLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.3, delay: index * 0.1 }}
                            whileHover={{ y: -4, scale: 1.02 }}
                            className="group block bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300"
                          >
                              
                            
                            <div className="p-4">
                              <h4 className="font-bold text-gray-900 text-base mb-1 group-hover:text-blue-600 transition-colors line-clamp-2">
                                {report.companyName}
                              </h4>
                              <div className="flex items-center justify-between mt-3">
                                <div className="flex items-center gap-2 text-xs text-gray-500">
                                  <FaCalendarAlt className="text-gray-400" />
                                  <span>{report.reportDate}</span>
                                </div>
                                <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full flex items-center gap-1">
                                  <FaDownload className="text-xs" />
                                  Open PDF
                                </span>
                              </div>
                              {report.additionalInfo && (
                                <p className="text-xs text-gray-500 mt-2 line-clamp-1">
                                  {report.additionalInfo}
                                </p>
                              )}
                            </div>
                          </motion.a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </motion.div>
            )}

            {/* Google Form Section - Display only if Google Form link exists */}
            {processedData.googleForm && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.15 }}
                className="mt-12"
              >
                <div className="bg-gradient-to-r from-purple-50 to-purple-50 rounded-2xl border border-purple-200 overflow-hidden shadow-sm">
                  <div className="bg-gradient-to-r from-purple-600 to-purple-600 px-6 py-4 flex items-center justify-between">
                    <div className="">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2">
                        <FaGoogle className="text-white text-2xl" />
                        {processedData.googleForm.title}
                       
                      </h3>
                     
                    </div>
                    <div>
                        <a
                          href={processedData.googleForm.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex-shrink-0"
                        >
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="px-6 py-3 bg-gradient-to-r from-purple-500 to-purple-500 hover:from-purple-600 hover:to-purple-600 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex items-center gap-3"
                          >
                            <FaGoogle className="text-lg" />
                            Fill Google Form
                            <FaArrowRight className="text-sm group-hover:translate-x-1 transition-transform" />
                          </motion.button>
                        </a>
                      </div>
                  </div>
                  
   
                </div>
              </motion.div>
            )}

            {/* Disclosures Section */}
            {processedData.disclosures.length > 0 && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="mt-12"
              >
                <div className="bg-gradient-to-r from-gray-50 to-white rounded-2xl border border-gray-200 p-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <FaShieldAlt className="text-blue-500" />
                    Regulatory Disclosures
                  </h3>
                  
                  <div className="space-y-6">
                    {processedData.disclosures.map((disclosure, index) => {
                      let title = '';
                      let icon = null;
                      let color = 'text-gray-700';
                      
                      if (disclosure.type === 'registration') {
                        title = 'SEBI Registration';
                        icon = <FaShieldAlt className="text-blue-500" />;
                        color = 'text-blue-700';
                      } else if (disclosure.type === 'risk') {
                        title = 'Risk Disclosure';
                        icon = <FaExclamationTriangle className="text-amber-500" />;
                        color = 'text-amber-700';
                      } else if (disclosure.type === 'disclaimer') {
                        title = 'Disclaimer';
                        icon = <FaFileAlt className="text-purple-500" />;
                        color = 'text-purple-700';
                      } else if (disclosure.type === 'caution') {
                        title = 'Investor Caution';
                        icon = <FaExclamationTriangle className="text-red-500" />;
                        color = 'text-red-700';
                      }
                      
                      return (
                        <div key={index} className={`${color} bg-white/50 p-5 rounded-xl border border-gray-100`}>
                          <div className="flex items-start gap-3">
                            <div className="mt-1">{icon}</div>
                            <div>
                              <h4 className="font-bold mb-2">{title}</h4>
                              <p className="text-sm leading-relaxed opacity-90 whitespace-pre-line">
                                {disclosure.text.replace(/\r\n/g, '\n')}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </motion.div>
            )}

            {/* Footer */}
            <div className="mt-8 text-center text-sm text-gray-500">
              {lastUpdated && (
                <p className="mt-1">Last refreshed: {lastUpdated.toLocaleString()}</p>
              )}
              <p className="mt-2 text-xs bg-gray-100 inline-block px-3 py-1 rounded-full">
                Market Maestroo Private Limited | SEBI Registration No: INH000021757 | Principal Officer: Kritika Yadav
              </p>
              {columnHeaders.length > 0 && (
                <div className="mt-3 text-xs text-gray-400">
                  {/* <p>Displaying all {columnHeaders.length} columns dynamically from Google Sheets</p> */}
                </div>
              )}
            </div>
          </div>
        </div>
      <Footer />
    </>
  );
};

export default AllWeatherPortfolio;